<template>
  <MaintenancePlan />

</template>

<script>
import MaintenancePlan from "../maintenance/MaintenancePlan.vue";
export default {
  components: {
    MaintenancePlan,
  },
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>

<style lang="scss" scoped>
</style>